import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe para formatar percentuais
 */
@Pipe({
    name: 'percentFormat'
})
export class PercentFormatPipe implements PipeTransform {

    transform(value: number,
              minIntegerDigits: number = 1,
              minFractionDigits: number = 0,
              maxFractionDigits: number = 2,
              nullIsZero = false) {
        if (value == null) {
            if (!nullIsZero) {
                return '';
            }
            value = 0;
        }
        if (typeof value !== 'number') {
            value = Number(value);
        }

        return `${value.toLocaleString('pt-br', {style: 'decimal', minimumIntegerDigits: minIntegerDigits, minimumFractionDigits: minFractionDigits, maximumFractionDigits: maxFractionDigits})}%`;
    }
}
